import { z } from 'zod';

const NAME_MAX_LENGTH = 1024;
export const UNSAVED_CHANGES_ERROR_MESSAGE = 'กรุณาบันทึกการเปลี่ยนแปลงก่อนดำเนินการต่อ';
export const NON_INFO_NAME_PLACEHOLDER = 'ไม่ระบุ';
export const NON_NAME_PLACEHOLDER = 'กรุณาระบุชื่อ';

export const QBankStructureLevelFormSchema = z.record(
  z.string().uuid(),
  z
    .string()
    .max(NAME_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .nullish(),
);

export type QBankStructureLevelFormInput = z.infer<typeof QBankStructureLevelFormSchema>;
